import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

export interface SelectOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss']
})
export class MultiselectComponent {

  @Input() options: SelectOption[] = [];
  @Input() label = 'Dietary Preferences';
  @Output() valueChange = new EventEmitter<string[]>();
  @Input() selectedValues: string[] = [];

  constructor(private elementRef: ElementRef) { }

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  get availableOptions() {
    return this.options.filter(
      option => !this.selectedValues.includes(option.value)
    );
  }

  toggleOption(option: SelectOption) {
    if (this.selectedValues.includes(option.value)) {
      this.selectedValues = this.selectedValues.filter(v => v !== option.value);
    } else {
      this.selectedValues.push(option.value);
    }

    this.valueChange.emit(this.selectedValues);
  }

  remove(value: string) {
    this.selectedValues = this.selectedValues.filter(v => v !== value);
    this.valueChange.emit(this.selectedValues);
  }

  isSelected(option: SelectOption): boolean {
    return this.selectedValues.includes(option.value);
  }

  getLabel(value: string): string {
    var option = this.options.find(function (o) {
      return o.value === value;
    });

    return option && option.label ? option.label : value;
  }
}
